import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

export const Layout = () => import("@/layout/index.vue");

// 静态路由
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    component: Layout,
    name: "index",
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          noMenu: true,
          noTag: true,
        },
      },
      {
        path: "404",
        component: () => import("@/views/error-page/404.vue"),
      },
      {
        path: "403",
        component: () => import("@/views/error-page/403.vue"),
      },
    ],
  },
  {
    path: "/loading",
    component: () => import("@/views/loading/index.vue"),
    meta: {
      noMenu: true,
      noTag: true,
      hidden: true,
    },
  },
  {
    path: "/iframe",
    component: () => import("@/views/iframe/index.vue"),
    meta: {
      noMenu: true,
    },
  },
  {
    path: "/login/:tenantCode?",
    component: () => import("@/views/login/index.vue"),
  },
  {
    path: "/system",
    component: Layout,
    children: [
      {
        path: "dept",
        component: () => import("@/views/system/dept/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "menu",
        component: () => import("@/views/system/menu/index.vue"),
      },
      {
        path: "user",
        component: () => import("@/views/system/user/index.vue"),
      },
      {
        path: "dict",
        name: "DictType",
        component: () => import("@/views/system/dict/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "role",
        component: () => import("@/views/system/role/index.vue"),
      },
      {
        path: "basic",
        name: "BasicIndex",
        component: () => import("@/views/system/basic/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "field",
        name: "FieldIndex",
        component: () => import("@/views/system/field/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/property",
    component: Layout,
    children: [
      {
        path: "home",
        name: "PropertyIndex",
        component: () => import("@/views/property/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "term",
        name: "TermIndex",
        component: () => import("@/views/property/term/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "term/library/detail/company",
        name: "CompanyTermLibraryDetail",
        component: () =>
          import("@/views/property/term/detail/company/index.vue"),
        meta: {
          keepAlive: true,
          hidden: true,
        },
      },
      {
        path: "term/library/detail/custom",
        name: "CustomTermLibraryDetail",
        component: () =>
          import("@/views/property/term/detail/custom/index.vue"),
        meta: {
          keepAlive: true,
          hidden: true,
        },
      },
      {
        path: "corpus",
        name: "CorpusIndex",
        component: () => import("@/views/property/corpus/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "corpus/library/detail",
        name: "CompanyCorpusLibraryDetail",
        component: () => import("@/views/property/corpus/detail/index.vue"),
        meta: {
          keepAlive: true,
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/project",
    component: Layout,
    children: [
      {
        path: "manager",
        name: "ProjectManager",
        component: () => import("@/views/project/manager/index.vue"),
      },
      {
        path: "index",
        name: "ProjectIndex",
        component: () => import("@/views/project/index/index.vue"),
      },
      {
        path: "completed",
        name: "ProjectCompleted",
        component: () => import("@/views/project/completed/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "add",
        name: "ProjectAdd",
        component: () => import("@/views/project/add/index.vue"),
        meta: {
          hidden: true,
          keepAlive: true,
        },
      },
      {
        path: "detail",
        name: "ProjectDetail",
        component: () => import("@/views/project/detail/index.vue"),
        meta: {
          hidden: true,
        },
      },
      {
        path: "task/add",
        name: "ProjectAddTask",
        component: () => import("@/views/project/task/newAdd.vue"),
        meta: {
          hidden: true,
          keepAlive: true,
        },
      },
      {
        path: "task/new_add",
        name: "ProjectAddTask2",
        component: () => import("@/views/project/task/newAdd.vue"),
        meta: {
          hidden: true,
          keepAlive: true,
          noMenu: true,
        },
      },
      {
        path: "task/taskDetail",
        name: "ProjectTaskDetail",
        component: () => import("@/views/project/task/detail/index.vue"),
        meta: {
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/task",
    component: Layout,
    children: [
      {
        path: "",
        name: "TaskType",
        component: () => import("@/views/task/index.vue"),
      },
      {
        path: "translations",
        name: "TranslationsType",
        component: () => import("@/views/task/translations/index.vue"),
      },
      {
        path: "preview/unclaimed",
        name: "UnclaimedIndex",
        component: () => import("@/views/task/preview/unclaimed/index.vue"),
        meta: {
          keepAlive: true,
          noMenu: true,
        },
      },
      {
        path: "preview/progressing",
        name: "ProgressingIndex",
        component: () => import("@/views/task/preview/progressing/index.vue"),
        meta: {
          keepAlive: true,
          noMenu: true,
        },
      },
      {
        path: "preview/completed",
        name: "CompletedIndex",
        component: () => import("@/views/task/preview/completed/index.vue"),
        meta: {
          keepAlive: true,
          noMenu: true,
        },
      },
    ],
  },
  {
    path: "/console",
    component: Layout,
    children: [
      {
        path: "",
        name: "TaskIndex",
        component: () => import("@/views/console/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "task",
        name: "TaskIndex",
        component: () => import("@/views/console/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/toolbox",
    component: Layout,
    children: [
      {
        path: "term/extraction",
        name: "TermExtraction",
        component: () => import("@/views/toolbox/term/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/template",
    component: Layout,
    children: [
      {
        path: "table",
        component: () => import("@/views/template/table/index.vue"),
      },
      {
        path: "statistics",
        component: () => import("@/views/template/statistics.vue"),
      },
    ],
  },
];

/**
 * 创建路由
 */
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes as RouteRecordRaw[],
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

// 回登录页
export function goLogin() {
  const tenantCode = localStorage.getItem("tenantCode");
  router.push("/login/" + tenantCode);
}

export default router;
